import client from '../utils/client';
import { couponsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const couponService = {
  couponsList,
  addCoupon,
  getCoupon,
  updateCoupon
}

function couponsList(pageID, perPage) {
  return client.get(couponsUrl + '?page=' + pageID + '&per_page=' + perPage)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addCoupon(formDate) {
  console.log(formDate);
  return client.post(couponsUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getCoupon(couponID) {
  return client.get(couponsUrl + '/' + couponID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateCoupon(formDate) {
  return client.post(couponsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}


function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}